import { BaseUrl } from "../../BaseUrl/BaseUrl";
import {
  getApiWithAuthorization,
  getApiWithoutAuthorization,
  postApiWithAuthorization,
} from "../ApiMethod/ApiMethod";

const Prasadurl = `${BaseUrl}/Temple`;

export const GetTempleCityList = async () => {
  const url = `${Prasadurl}/GetTempleCityList`;
  const res = await getApiWithAuthorization(url);
  return res;
};

export const GetTempleList = async (DistrictID) => {
  const url = `${Prasadurl}/GetTempleList?DistrictID=${DistrictID}`;
  const res = await getApiWithAuthorization(url);
  return res;
};

export const TempleDetailsBySlug = async (Slug) => {
  const url = `${Prasadurl}/TempleDetailsBySlug?Slug=${Slug}`;
  const res = await getApiWithAuthorization(url);
  return res;
};
export const TempleLookUpList = async (Slug) => {
  const url = `${Prasadurl}/TempleLookUpList`;
  const res = await getApiWithAuthorization(url);
  return res;
};